import * as types from '../mutation-types'
import axios from '../../common/axios.js'
import _ from 'lodash'
import utils from '../../common/utils.js'


// initial state
const state = {
	drawingMode: null,
	elements: [],
	pictos: {
		pin: {
			label               : 'Pin',
			url                 : `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
									<path fill="#3C4043" fill-rule="evenodd" clip-rule="evenodd" d="M12 7C10.8954 7 10 7.89543 10 9C10 10.1046 10.8954 11 12 11C13.1046 11 14 10.1046 14 9C14 7.89543 13.1046 7 12 7ZM8 9C8 6.79086 9.79086 5 12 5C14.2091 5 16 6.79086 16 9C16 11.2091 14.2091 13 12 13C9.79086 13 8 11.2091 8 9Z"/>
									<path fill="#3C4043" fill-rule="evenodd" clip-rule="evenodd" d="M12 3C10.1311 3 8.34627 3.71423 7.03625 4.97386C5.72757 6.2322 5 7.93034 5 9.69231C5 12.7799 6.79758 15.6218 8.74169 17.7716C9.69983 18.831 10.6608 19.6861 11.3828 20.2762C11.6175 20.468 11.826 20.6311 12 20.7634C12.174 20.6311 12.3825 20.468 12.6172 20.2762C13.3392 19.6861 14.3002 18.831 15.2583 17.7716C17.2024 15.6218 19 12.7799 19 9.69231C19 7.93034 18.2724 6.2322 16.9637 4.97386C15.6537 3.71423 13.8689 3 12 3ZM12 22C11.4416 22.8296 11.4414 22.8294 11.441 22.8292L11.4382 22.8273L11.4319 22.823L11.4108 22.8086C11.393 22.7963 11.3677 22.7789 11.3356 22.7563C11.2714 22.7113 11.1796 22.6458 11.0641 22.5609C10.8331 22.3912 10.5069 22.1433 10.1172 21.8248C9.33915 21.1889 8.30017 20.2651 7.25831 19.1131C5.20242 16.8397 3 13.5278 3 9.69231C3 7.37403 3.95814 5.15902 5.65004 3.53219C7.3406 1.90665 9.62543 1 12 1C14.3746 1 16.6594 1.90665 18.35 3.53219C20.0419 5.15902 21 7.37403 21 9.69231C21 13.5278 18.7976 16.8397 16.7417 19.1131C15.6998 20.2651 14.6608 21.1889 13.8828 21.8248C13.4931 22.1433 13.1669 22.3912 12.9359 22.5609C12.8204 22.6458 12.7286 22.7113 12.6644 22.7563C12.6323 22.7789 12.607 22.7963 12.5892 22.8086L12.5681 22.823L12.5618 22.8273L12.5597 22.8287C12.5594 22.8289 12.5584 22.8296 12 22ZM12 22L12.5584 22.8296C12.2208 23.0568 11.7786 23.0564 11.441 22.8292L12 22Z"/>
								   </svg>`,
			scaledSize          : {width: 24, height: 24},
			anchor              : {x: 12, y: 24},
			labelOrigin         : {x: 12, y: -10},
			fillColor           : '#3C4043',
			canModifyFillColor  : true,
			canModifyStrokeColor: false
		},
		silo: {
			label               : 'Silo',
			url                 : `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"> 
									<path stroke="#3C4043" stroke-opacity="0.99" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="M2 20H22"/>
									<path stroke="#3C4043" stroke-opacity="0.99" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="M19.6683 12.6426L15.1683 8.59986C14.7882 8.25838 14.2118 8.25838 13.8317 8.59986L9.33169 12.6426C9.12058 12.8323 9 13.1027 9 13.3865V19.9995H19C19.5523 19.9995 20 19.5517 20 18.9995V13.3865C20 13.1027 19.8794 12.8323 19.6683 12.6426Z"/>
									<path stroke="#3C4043" stroke-opacity="0.99" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="M9 20H5C4.44772 20 4 19.5523 4 19V5C4 4.44772 4.44772 4 5 4H11C11.5523 4 12 4.44772 12 5V10"/>
								   </svg>`,
			scaledSize          : {width: 24, height: 24},
			anchor              : {x: 12, y: 12},
			labelOrigin         : {x: 12, y: -10},
			strokeColor         : '#3C4043',
			canModifyFillColor  : false,
			canModifyStrokeColor: true
		},
		star: {
			label               : 'Etoile',
			url                 : `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path fill="#3C4043" fill-opacity="0.99" fill-rule="evenodd" clip-rule="evenodd" d="M12 1C12.3806 1 12.7283 1.21607 12.8967 1.55738L15.7543 7.34647L22.1447 8.28051C22.5212 8.33555 22.8339 8.59956 22.9513 8.96157C23.0687 9.32358 22.9704 9.72083 22.6978 9.98636L18.0746 14.4894L19.1656 20.851C19.23 21.2261 19.0757 21.6053 18.7678 21.8291C18.4598 22.0528 18.0515 22.0823 17.7146 21.9051L12 18.8998L6.28548 21.9051C5.94856 22.0823 5.54027 22.0528 5.2323 21.8291C4.92432 21.6053 4.77007 21.2261 4.83442 20.851L5.92551 14.4894L1.3023 9.98636C1.02968 9.72083 0.931405 9.32358 1.04878 8.96157C1.16616 8.59956 1.47884 8.33555 1.8554 8.28051L8.24577 7.34647L11.1033 1.55738C11.2718 1.21607 11.6194 1 12 1ZM12 4.25925L9.80674 8.70262C9.6612 8.99747 9.38001 9.20193 9.05466 9.24949L4.14844 9.9666L7.69776 13.4236C7.93364 13.6534 8.0413 13.9845 7.98564 14.309L7.14821 19.1917L11.5346 16.8849C11.826 16.7317 12.1741 16.7317 12.4655 16.8849L16.8518 19.1917L16.0144 14.309C15.9588 13.9845 16.0664 13.6534 16.3023 13.4236L19.8516 9.9666L14.9454 9.24949C14.62 9.20193 14.3389 8.99747 14.1933 8.70262L12 4.25925Z"/>
								   </svg>`,
			scaledSize          : {width: 24, height: 24},
			anchor              : {x: 12, y: 12},
			labelOrigin         : {x: 12, y: -10},
			fillColor           : '#3C4043',
			canModifyFillColor  : true,
			canModifyStrokeColor: false
		},
		persona: {
			label               : 'Personne',
			url                 : `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path stroke="#3C4043" stroke-opacity="0.99" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="M12 13C13.6569 13 15 11.6569 15 10C15 8.34315 13.6569 7 12 7C10.3431 7 9 8.34315 9 10C9 11.6569 10.3431 13 12 13Z"/>
									<path stroke="#3C4043" stroke-opacity="0.99" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="M20 3H4C3.44772 3 3 3.44772 3 4V20C3 20.5523 3.44772 21 4 21H20C20.5523 21 21 20.5523 21 20V4C21 3.44772 20.5523 3 20 3Z"/>
									<path stroke="#3C4043" stroke-opacity="0.99" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="M7 21C7 18.2386 9.23858 16 12 16C14.7614 16 17 18.2386 17 21"/>
								   </svg>`,
			scaledSize          : {width: 24, height: 24},
			anchor              : {x: 12, y: 12},
			labelOrigin         : {x: 12, y: -10},
			fillColor           : '#3C4043',
			canModifyFillColor  : false,
			canModifyStrokeColor: true
		},
		car: {
			label               : 'Voiture',
			url                 : `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path fill="#3C4043" fill-opacity="0.99" d="M19 9.50001H18.68L17.43 6.38001C17.2068 5.82527 16.8228 5.3499 16.3275 5.01492C15.8321 4.67993 15.248 4.50063 14.65 4.50001H8.65C7.95529 4.49802 7.28142 4.7372 6.74342 5.17673C6.20541 5.61625 5.83662 6.22886 5.7 6.91001L5.18 9.50001H5C4.20435 9.50001 3.44129 9.81608 2.87868 10.3787C2.31607 10.9413 2 11.7044 2 12.5V15.5C2 15.7652 2.10536 16.0196 2.29289 16.2071C2.48043 16.3947 2.73478 16.5 3 16.5H4C4 17.2957 4.31607 18.0587 4.87868 18.6213C5.44129 19.1839 6.20435 19.5 7 19.5C7.79565 19.5 8.55871 19.1839 9.12132 18.6213C9.68393 18.0587 10 17.2957 10 16.5H14C14 17.2957 14.3161 18.0587 14.8787 18.6213C15.4413 19.1839 16.2044 19.5 17 19.5C17.7956 19.5 18.5587 19.1839 19.1213 18.6213C19.6839 18.0587 20 17.2957 20 16.5H21C21.2652 16.5 21.5196 16.3947 21.7071 16.2071C21.8946 16.0196 22 15.7652 22 15.5V12.5C22 11.7044 21.6839 10.9413 21.1213 10.3787C20.5587 9.81608 19.7956 9.50001 19 9.50001ZM13 6.50001H14.65C14.8486 6.50181 15.0421 6.56269 15.206 6.67488C15.3698 6.78708 15.4965 6.94552 15.57 7.13001L16.52 9.50001H13V6.50001ZM7.66 7.30001C7.70675 7.07074 7.83242 6.86511 8.01514 6.71894C8.19786 6.57277 8.42605 6.49529 8.66 6.50001H11V9.50001H7.22L7.66 7.30001ZM7 17.5C6.80222 17.5 6.60888 17.4414 6.44443 17.3315C6.27998 17.2216 6.15181 17.0654 6.07612 16.8827C6.00043 16.7 5.98063 16.4989 6.01921 16.3049C6.0578 16.1109 6.15304 15.9328 6.29289 15.7929C6.43275 15.6531 6.61093 15.5578 6.80491 15.5192C6.99889 15.4806 7.19996 15.5004 7.38268 15.5761C7.56541 15.6518 7.72159 15.78 7.83147 15.9444C7.94135 16.1089 8 16.3022 8 16.5C8 16.7652 7.89464 17.0196 7.70711 17.2071C7.51957 17.3947 7.26522 17.5 7 17.5ZM17 17.5C16.8022 17.5 16.6089 17.4414 16.4444 17.3315C16.28 17.2216 16.1518 17.0654 16.0761 16.8827C16.0004 16.7 15.9806 16.4989 16.0192 16.3049C16.0578 16.1109 16.153 15.9328 16.2929 15.7929C16.4327 15.6531 16.6109 15.5578 16.8049 15.5192C16.9989 15.4806 17.2 15.5004 17.3827 15.5761C17.5654 15.6518 17.7216 15.78 17.8315 15.9444C17.9414 16.1089 18 16.3022 18 16.5C18 16.7652 17.8946 17.0196 17.7071 17.2071C17.5196 17.3947 17.2652 17.5 17 17.5ZM20 14.5H19.22C18.9388 14.1907 18.5961 13.9435 18.2138 13.7743C17.8315 13.6052 17.418 13.5178 17 13.5178C16.582 13.5178 16.1685 13.6052 15.7862 13.7743C15.4039 13.9435 15.0612 14.1907 14.78 14.5H9.22C8.93882 14.1907 8.59609 13.9435 8.21378 13.7743C7.83148 13.6052 7.41805 13.5178 7 13.5178C6.58195 13.5178 6.16852 13.6052 5.78622 13.7743C5.40391 13.9435 5.06118 14.1907 4.78 14.5H4V12.5C4 12.2348 4.10536 11.9804 4.29289 11.7929C4.48043 11.6054 4.73478 11.5 5 11.5H19C19.2652 11.5 19.5196 11.6054 19.7071 11.7929C19.8946 11.9804 20 12.2348 20 12.5V14.5Z"/>
								   </svg>`,
			scaledSize          : {width: 24, height: 24},
			anchor              : {x: 12, y: 12},
			labelOrigin         : {x: 12, y: -10},
			fillColor           : '#3C4043',
			canModifyFillColor  : true,
			canModifyStrokeColor: false
		},
		compagny: {
			label               : 'Entreprise',
			url                 : `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path stroke="#3C4043" stroke-opacity="0.99" stroke-width="2" stroke-linecap="round" d="M4.5 21V3.7C4.5 3.58954 4.58954 3.5 4.7 3.5H8.3C8.41046 3.5 8.5 3.58954 8.5 3.7V10.974C8.5 11.1579 8.7273 11.2443 8.84948 11.1068L12.1505 7.39317C12.2727 7.25572 12.5 7.34214 12.5 7.52604V10.974C12.5 11.1579 12.7273 11.2443 12.8495 11.1068L16.1505 7.39317C16.2727 7.25572 16.5 7.34214 16.5 7.52604V10.974C16.5 11.1579 16.7273 11.2443 16.8495 11.1068L20.1505 7.39317C20.2727 7.25572 20.5 7.34214 20.5 7.52604V21M4.5 21H2.5M4.5 21H20.5M21.5 21H20.5"/>
								   </svg>`,
			scaledSize          : {width: 24, height: 24},
			anchor              : {x: 12, y: 12},
			labelOrigin         : {x: 12, y: -10},
			fillColor           : '#3C4043',
			canModifyFillColor  : false,
			canModifyStrokeColor: true
		},
		house: {
			label               : 'Maison',
			url                 : `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path stroke="#3C4043" stroke-opacity="0.99" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="M3 9L12 2L21 9V20C21 20.5304 20.7893 21.0391 20.4142 21.4142C20.0391 21.7893 19.5304 22 19 22H5C4.46957 22 3.96086 21.7893 3.58579 21.4142C3.21071 21.0391 3 20.5304 3 20V9Z"/>
									<path stroke="#3C4043" stroke-opacity="0.99" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="M9 22V12H15V22"/>
								   </svg>`,
			scaledSize          : {width: 24, height: 24},
			anchor              : {x: 12, y: 12},
			labelOrigin         : {x: 12, y: -10},
			fillColor 			: '#3C4043',
			canModifyFillColor  : false,
			canModifyStrokeColor: true
		},
		circle: {
			label               : 'Cercle',
			url                 : `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
									<path fill="#14181F" fill-rule="evenodd" clip-rule="evenodd" d="M12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4ZM2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12Z"/>
									<path fill="#14181F" fill-rule="evenodd" clip-rule="evenodd" d="M12 10C12.5523 10 13 10.4477 13 11V16C13 16.5523 12.5523 17 12 17C11.4477 17 11 16.5523 11 16V11C11 10.4477 11.4477 10 12 10Z"/>
									<path fill="#14181F" class="" fill-rule="evenodd" clip-rule="evenodd" d="M10.9502 8C10.9502 7.44772 11.3979 7 11.9502 7H12.0502C12.6025 7 13.0502 7.44772 13.0502 8V8.1C13.0502 8.65228 12.6025 9.1 12.0502 9.1H11.9502C11.3979 9.1 10.9502 8.65228 10.9502 8.1V8Z"/>
								   </svg>`,
			scaledSize          : {width: 24, height: 24},
			anchor              : {x: 12, y: 12},
			labelOrigin         : {x: 12, y: -10},
			fillColor 			: '#3C4043',
			canModifyFillColor  : true,
			canModifyStrokeColor: false
		}
	}
}

// getters
const getters = {
	getCircles(){
		let circles = state.elements.filter(element => element.type === 'circle')
		return circles
	},
	getRectangles(){
		let rectangles = state.elements.filter(element => element.type === 'rectangle')
		return rectangles
	},
	getMarkers(){
		let markers = state.elements.filter(element => element.type === 'marker')
		return markers
	},
	getPolygons(){
		let polygons = state.elements.filter(element => element.type === 'polygon')
		return polygons
	},
	getPolylines(){
		let polyline = state.elements.filter(element => element.type === 'polyline')
		return polyline
	},
	getTexts(){
		let texts = state.elements.filter(element => element.type === 'text')
		return texts
	},
	getAnnotationsForSave(){
		let elements = _.cloneDeep(state.elements)

		if(elements?.length > 0){
			//Parcours tous les éléments pour les désélectionner
			elements.forEach(element => {
				element.selected = false
			})
		}
		return elements
	},
	hasDrawingMode(){
		return state.drawingMode ? true : false
	}
}

// actions
const actions = {
	addAnnotationsElement({ commit, rootState, dispatch }, element) {
		console.log('addAnnotationsElement', element)

		if(!rootState.ui.recherche_edition) dispatch('exitSearch');

		element.id = utils.methods.generateId()
		element.selected = false

		element.zindex = state.elements.length +1

		let elements = state.elements
		elements.push(element)
		commit('ANNOTATIONS_SET_ELEMENTS', elements)
		dispatch('toggleSelectAnnotationsElement', element.id)

	},
	updateAnnotationsElement({ commit, rootState, dispatch }, new_values) { // new_values = { id: 'element_id', val1: '...', val2: '...', ... }
		console.log('updateAnnotationsElement', new_values)

		if(!rootState.ui.recherche_edition) dispatch('exitSearch');

		let elements   = _.cloneDeep(state.elements)
		let index      = elements.findIndex(e => e.id === new_values.id)
		let old_values = elements[index]

		let run_update = false

		//Compare les valeurs de element par rapport à elements[index] et ne fait rien si toutes les clés de element ont les mêmes valeurs que les clés de elements[index]. Prendre en compte toutes les clés possibles et inconnues
		_.forEach(new_values, (value, key) => {
			if(!_.isEqual(value, old_values[key])) run_update = true
		})

		if(run_update){
			elements[index] = { ...elements[index], ...new_values }
			commit('ANNOTATIONS_SET_ELEMENTS', elements)
		}
	},
	deleteAllAnnotationsElements({ commit, rootState, dispatch }) {
		console.log('deleteAllAnnotationsElements')
		if(!rootState.ui.recherche_edition) dispatch('exitSearch');
		commit('ANNOTATIONS_SET_ELEMENTS', [])
	},
	deleteAnnotationsElement({ commit, rootState, dispatch }, id) {
		if(!rootState.ui.recherche_edition) dispatch('exitSearch');
		let elements = _.cloneDeep(state.elements).filter(e => e.id !== id)
		commit('ANNOTATIONS_SET_ELEMENTS', elements)
	},
	setAnnotationsDrawingMode({ commit, dispatch }, mode) {
		commit('ANNOTATIONS_SET_DRAWING_MODE', mode)
		if(mode === 'text') dispatch('set_map_coords', 'text')
		if(mode === null) dispatch('set_map_coords', false)
	},
	toggleSelectAnnotationsElement({ commit }, id) {
		let elements = _.cloneDeep(state.elements)
		elements.forEach(element => {
			if(element.id === id) {
				element.selected = !element.selected
			} else {
				element.selected = false
			}
		})
		commit('ANNOTATIONS_SET_ELEMENTS', elements)
	},
}

// mutations
const mutations = {
	ANNOTATIONS_SET_ELEMENTS(state, elements) {
		state.elements = elements
	},
	ANNOTATIONS_SET_DRAWING_MODE(state, mode) {
		console.log('areMapToolsActive ANNOTATIONS_SET_DRAWING_MODE', mode)
		state.drawingMode = _.cloneDeep(mode)
	}
}

export default {
	state,
	getters,
	actions,
	mutations
}